// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3mz60","footer":"ModalFilter_footer__18j2v"};